import * as React from "react";
import * as moment from "moment";
import { MouseEvent } from "react";

import { DebtorType, Nullable } from "types";
import { Deedle } from "components";
import { numberToPhone } from "utils/formatters";

const dob = (date: Nullable<string>): string =>
  date ? moment(date).format("MM/DD/YYYY") : "None given";

const debtorAddress = (debtor: DebtorType): JSX.Element => {
  const { city, state, street1, street2, zip } = debtor;

  return (
    <>
      <div>{[street1, street2].join(`\n`)}</div>
      <div>{`${city}, ${state} ${zip}`}</div>
    </>
  );
};

interface PropsType {
  debtor: DebtorType;
  onEdit: (event: MouseEvent) => void;
}

export default function PersonalInfo(props: PropsType): JSX.Element {
  const { debtor, onEdit } = props;

  return (
    <section data-test-id="personalInfo">
      <div>
        <h2>Personal Info</h2>
        <a href="#" onClick={onEdit}>
          Edit
        </a>
      </div>
      <Deedle term="Name" definition={debtor.fullName} />
      <Deedle term="Email" definition={debtor.email} />
      <Deedle term="Address" definition={debtorAddress(debtor)} />
      {debtor.phone1 && (
        <Deedle term="Phone" definition={numberToPhone(debtor.phone1)} />
      )}
      <Deedle term="Date of birth" definition={dob(debtor.dateOfBirth)} />
    </section>
  );
}
